import React from 'react';

import { useHistory } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import LegacyIconButton from 'components/IconButton';

function BackButton({ onBack, ...props }) {
  const history = useHistory();

  return (
    <LegacyIconButton
      variant="transparent"
      onClick={() => {
        if (onBack) {
          onBack();
        } else {
          history.goBack();
        }
      }}
      {...props}
    >
      <ArrowBackIcon />
    </LegacyIconButton>
  );
}
export default BackButton;
